/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kiotviet_Item_Link_ButtonInputs */

const vi_kiotviet_item_link_button = /** @type {(inputs: Kiotviet_Item_Link_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nối sản phẩm`)
};

/**

* @param {Kiotviet_Item_Link_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_item_link_button = /** @type {((inputs?: Kiotviet_Item_Link_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Item_Link_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_item_link_button(inputs)
});